import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { useSelector } from 'react-redux';

const ExpenseBarChart = ({ data, currency }) => {
  const colors = useSelector((state) => state?.persistedReducer?.colors);
  if (!data || data.length === 0) {
    return <p>No data available</p>;
  }

  const categories = data.map((item) => item.name_of_property);
  const seriesData = data.map((item) => parseFloat(item.total_expense));

  const currencyCodeMap = {
    "Indian Rupee": "INR",
    "US Dollar": "USD",
    "Euro": "EUR",
    "British Pound": "GBP",
    "Japanese Yen": "JPY",
    "Rupees": "INR"
  };

  const currencyCode = currencyCodeMap[currency?.currency_name] || "USD";
  const currencySymbol = currency?.currency_symbol || "$";


  // Format the currency according to the selected currency
  const formatCurrency = (value, showDecimals = true) => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: currencyCode,
      minimumFractionDigits: showDecimals ? 2 : 0,
      maximumFractionDigits: showDecimals ? 2 : 0,
    }).format(value);
  };

  const formatLabel = (value) => {
    if (value >= 1_000_000_000_000) {
      return `${currencySymbol}${(value / 1_000_000_000_000).toFixed(2)}T`;
    } else if (value >= 1_000_000_000) {
      return `${currencySymbol}${(value / 1_000_000_000).toFixed(2)}B`;
    } else if (value >= 1_000_000) {
      return `${currencySymbol}${(value / 1_000_000).toFixed(1)}M`;
    } else {
      return `${currencySymbol}${value.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })}`;
    }
  };


  const options = {
    chart: {
      type: "column",
    },
    title: {
      text: "Most Expenses Incurred Properties",
      align: 'left',
      style: {
        color: colors?.secondary ?? '#000',
      },
    },
    xAxis: {
      categories: categories,
      title: {
        text: "Properties",
      },
      labels: {
        formatter: function () {
          return this.value;
        },
        style: {
          width: "100px",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        },
      },
    },
    yAxis: {
      title: {
        text: `Total Expense (${currencySymbol})`,
      },
      labels: {
        formatter: function () {
          return formatLabel(this.value);
        },
        style: {
          fontSize: "12px",
        },
      },
    },
    series: [
      {
        name: "Total Expense",
        data: seriesData,
      },
    ],
    tooltip: {
      formatter: function () {
        return `<b>${this.x}</b><br/>Total Expense: <b>${formatCurrency(
          this.y
        )}</b>`;
      },
    },
    plotOptions: {
      column: {
        dataLabels: {
          enabled: true,
          formatter: function () {
            return formatCurrency(this.y, false);
          },
        },
      },
    },
    credits: {
      enabled: false,
    },
  };

  return <HighchartsReact highcharts={Highcharts} options={options} />;
};

export default ExpenseBarChart;
